import services from './../../../services/service'; // Service Class
import AccountResources from './../../Account/Resources/commonfunctions.js';

//
let service = new services();

export default {
    name: 'ManageOrders',
    mixins: [AccountResources],
    data () {
        return {
            headerdata:{'name':this.$route.name},
            users: {},
            user: {},
            business: {},
            sellpoints:{},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error:false,
            group_isset:false,
            add_sellpoint: false,
            add_business: false,
            get_flag:false,
            loading:false,
            action_loading:false,

            //messages
            validate_user_name_message: "",
            payment_successful_message:"",
            data_error_message: "",
            data_boarding_message: "",
            //
            headerdata:{
                'name':'Set Order',
            },

            //
            reset_order:false,
            set_in_view:'',
            set_inner_view:'',
            order_user_type:0,
        }
    },
    components: {
    },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages(){
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },

        preset() {
            this.loading = true;
            //../
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    self.site_user_type = 1; //user
                    self.user_type = 1; //user
                    if((self.$route.path == "/placed/orders") || (self.$route.name=="Placed Order")){
                        //
                        self.order_user_type = 1; //user
                        if(self.$route.params.ref && (self.$route.params.ref != '')){
                            //----synced 4 temp @coommomfunc getOrders func
                            //var payload = {ref:self.$route.params.ref}    
                            //self.getOrderDetails(payload,4);
                            //-----
                        }else{
                            //check if has sellpoints
                            self.getSellpoints(self.user.user_id);
                        }
                        self.getOrders(self.user.user_id,1);
                    }
                    else if(self.$route.path == "/manage/orders"){
                        self.order_user_type = 2; //business
                        self.site_user_type = 2; //business
                        self.user_type = 2; //business
                        localforage.getItem(service.bdb_name, function(err, value) { //quick with the callback version
                            if(value != undefined) {
                                self.sellpoint = value;
                                if(self.sellpoint.business_category_id == 37){
                                    self.order_user_type = 2; //delivery
                                    self.user_type = 3; //delivery
                                    self.getAppDeliveryPartnerOrders(1);
                                }else{
                                    self.getAppBusinessOrders(1);
                                }
                                //get some core details
                                self.setBusinessDetails();
                            }else{
                                self.loading = false;
                                self.getSellpoints(self.user.user_id);
                            }
                        });
                    }
                }else {
                    self.loading = false;
                    self.$router.push('/login')
                }
            });
        },

        setBusinessDetails(){
            //---bank-details
            let self = this;
            localforage.getItem(service.bbnksdb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint.business_bank_details = value;
                    self.business_bank_details = value;
                }
                self.loading = false;
            });
            //--delivery-locations
            localforage.getItem(service.bbdlsdb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint.business_delivery_options = value;
                    self.business_delivery_locations = value;
                }
                self.loading = false;
            });

            ///get/reset business-----set func at common...
            this.getSellpointDetails(this.sellpoint.business_username);
            ///--business
            ///banks
            //delivery locations
        },

        promptUpdateOrders(type){
            this.sortOrders(2,this.orders_store,2,type);
        },

        setOrderData(order){console.log(87655)
            this.order = order;
            //
            this.getOrderMedia();
            this.getOrderAdditionals();
            //this.getOrderChart();
            //
            var payload = {ref:order.order_no}    
            //this.getOrderDetails(payload,1);
            this.setMenuTabInnerView('viewOrder');
        },

        setViewBox(view){
            this.setMenuTabInnerView('setOptions');
            //
            this.set_view_box = view;
            //this.toggleSingleComponent(view);
        },

        setLike(){
            //close box if open
            if(document.getElementById('shareBox').style.display == 'block'){
                document.getElementById('shareBox').style.display = 'none'
            }
            this.order_item = this.order.order_items[0];
            if(this.is_liked == 0){
                this.is_liked = 1;
                this.customReview(62,64);
            }else{
                this.is_liked = 0;
                this.customReview(62,65);
            }
        },

        setRate(item,rate){
            this.order_item = item;
            this.order_item.product_item_rate = rate;
            //set rate
            // for (let i = 1; i <= rate; i++) {
                for (let i = 1; i <= 5; i++) {
                if(i <= rate){
                    document.getElementById('rate-'+i).style.display = 'none';
                    document.getElementById('rated-'+i).style.display = 'block';
                }else{
                    document.getElementById('rate-'+i).style.display = 'block';
                    document.getElementById('rated-'+i).style.display = 'none';
                }
            }
        },

        submitReview(type){
            // if((this.order_item.product_item_review == "") && (this.order_item.product_item_rate == 0)){
                this.order_item.data_processing_message = "Please review and rate";
            if((this.order_item.product_item_rate < 0)){
                this.data_processing_message = "Please rate";
            }else{
                this.activate_processing();
                var payload = {}; //ini
                //
                if(type == 3){ //delivery partner review
                    payload = {
                        'product_reviewed_by': this.user.user_id,
                        'product_id': 0,
                        'product_item_id': 0,
                        'product_item_order_cost': 0,
                        'product_review': this.order_item.product_item_review || '',
                        'product_rate': this.order_item.product_item_rate,
                        'product_review_module': 3, //business module
                        'product_review_module_id': this.order.order_delivery_business.business,
                        'product_review_at_module': 8, //order module
                        'product_review_at_module_id': this.order.order_id,
                    }
                }
                else{
                    payload = {
                        'product_reviewed_by': this.user.user_id,
                        'product_id': this.order_item.product_id,
                        'product_item_id': this.order_item.product_item_id,
                        'product_item_order_cost': this.order_item.order_item_total,
                        'product_review': this.order_item.product_item_review || '',
                        'product_rate': this.order_item.product_item_rate,
                        'product_review_module': 3, //business module
                        'product_review_module_id': this.order.order_business_no,
                        'product_review_at_module': 8, //order module
                        'product_review_at_module_id': this.order.order_id,
                    }
                }
                service.addProductReview(this, payload).then(response => {
                    if(response.body.status == 201) {
                        if(response.body.data_user_reviews){
                            //sort
                            let user_reviews = response.body.data_user_reviews;
                            let order_user_review = [];
                            let order_user_delivery_review = [];
                            for(let review of user_reviews){
                                if((review.product_review_module == 3) && (review.product_review_module_id == this.order.order_delivery_business.business)){
                                    order_user_delivery_review.push(review)
                                }else if((review.product_review_module == 3) && (review.product_review_module_id == this.order.order_business_no)){
                                    order_user_review.push(review)
                                }
                            }
                            this.order.order_user_review = order_user_review;
                            this.order.order_user_delivery_review = order_user_delivery_review;
                        }
                    }
                    this.deactivate_processing();
                }).catch((err) => {
                    this.deactivate_processing();
                })
            }
            this.componentOrderItemReviewKey++;
                
        },

        customReview(type,value){
            this.order_item.data_processing_message = "Please review and rate";
            if((this.order_item.product_item_rate < 0)){
                this.data_processing_message = "Please rate";
            }else{
                this.activate_processing();
                var payload = {
                    'product_reviewed_by': this.user.user_id,
                    'product_id': this.order_item.product_id,
                    'product_item_id': this.order_item.product_item_id,
                    'product_item_order_cost': this.order_item.order_item_total,
                    'product_review': '',
                    'product_rate':0,
                    'product_review_type': type,
                    'product_review_type_value_type': value,
                }
                service.addProductReview(this, payload).then(response => {
                    if(response.body.status == 201) {
                        this.deactivate_processing();
                    }
                }).catch((err) => {})
            }
            this.componentOrderItemReviewKey++;
                
        },

        setOrderReviews(){
            let item = this.order.order_items[0];
            for(let rv of item.order_item_reviews){
                //order review
                if(rv.product_review_type == 0){
                    this.order_rate = rv.product_rate;
                    this.setRate(item,this.order_rate)
                }else if(rv.product_review_type > 0){
                    //like
                    if(rv.product_review_type == 62){
                        if(rv.product_review_type_value_type == 64){
                            this.is_liked = 1;
                        }
                    }
                    //delivery
                    if(rv.product_review_type == 63){
                        if(rv.product_review_type_value_type == 64){
                            this.order_delivery_feedback = rv.this.order.order_delivery_feedback;
                            this.order_delivery_feedback_name = rv.rv.product_review_type_value_type_name;
                        }
                    }
                }

            }
            
        },

        //to aid views of both mobile and desktop
        set_toggleSingleComponent(view){
            this.toggleSingleComponent(view);
            if(this.site_view == 2){
                document.getElementById('popBox').style.display = 'block';
            }
            
        }
    },
    created: function(){
        //
        this.setScreenView();
        this.preset();
    }
}



// WEBPACK FOOTER //
// ./src/pages/Components/OrdersManagement/script.js